import { IconButton, Typography } from '@/shared/ui/atoms';

interface ModalHeaderProps {
  title?: string;
  titlePosition?: 'center' | 'left' | 'right';
  subTitle?: string;
  className?: string;
  onClose: () => void;
}

const ModalHeader = ({ title, titlePosition = 'left', subTitle, className, onClose }: ModalHeaderProps) => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  return (
    <div className={`relative ${className}`}>
      <div className="flex flex-col gap-[0.25rem]">
        {title && (
          <Typography as="p" className={`text-[1.375rem] leading-[2.125rem] md:text-[1.5rem] md:leading-[2.125rem] tracking-[-0.048rem] font-bold text-${titlePosition}`}>
            {title}
          </Typography>
        )}
        {subTitle && (
          <Typography as="p" className={`text-[1rem] leading-[1.3rem] tracking-[-0.0005rem] text-${titlePosition}`}>
            {subTitle}
          </Typography>
        )}
      </div>
      <div className="absolute md:top-[1.5rem] md:right-[2rem] top-[0.88rem] right-[1.06rem]">
        <IconButton url={`${baseImageUrl}/icons/close-black.png`} onClick={onClose} className="w-[1.5rem] h-[1.5rem] md:w-[2rem] md:h-[2rem]" />
      </div>
    </div>
  );
};

export default ModalHeader;
